import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import AppReducers from './scripts/reducers';
import App from './scripts/App';
import {createLogger} from 'redux-logger';
import reduxThunk from 'redux-thunk';

import registerServiceWorker from './registerServiceWorker';

const logger = createLogger();
let store = createStore(AppReducers, compose(applyMiddleware(reduxThunk, logger), window.devToolsExtension
    ? window.devToolsExtension()
    : f => f));

document.addEventListener('DOMContentLoaded', () => {
    render(
        <Provider store={store}>
        <App />
    </Provider>, document.getElementById('root'));
});

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js